import { InventorySKUListing } from '@views/StockBySKU/components/types';
import { Button } from '@tailwindComponents/Button';
import { SkuInfoModal as SharedSkuInfoModal } from '@tailwindComponents/SkuInfoModal';

export interface SkuInfoModalProps {
  sku: InventorySKUListing | null;
  isOpen: boolean;
  onClose: () => void;
  isWarehouseUser: boolean;
  onClone: (sku: InventorySKUListing) => void;
  onUpdate: (sku: InventorySKUListing) => void;
  onArchive: (sku: InventorySKUListing) => void;
}

export function SkuInfoModal({
  sku,
  isOpen,
  onClose,
  isWarehouseUser,
  onClone,
  onUpdate,
  onArchive,
}: SkuInfoModalProps) {
  return (
    <SharedSkuInfoModal
      sku={sku}
      isOpen={isOpen}
      onClose={onClose}
      actions={
        isWarehouseUser && sku ? (
          <>
            <Button
              intent='secondary'
              size='sm'
              label='Clone'
              onClick={() => onClone(sku)}
            />
            <Button
              intent='primary'
              size='sm'
              label='Edit'
              onClick={() => onUpdate(sku)}
            />
            <Button
              intent='danger'
              size='sm'
              label={sku.isArchived ? 'Unarchive' : 'Archive'}
              onClick={() => onArchive(sku)}
            />
          </>
        ) : null
      }
    />
  );
}
